module.exports = __webpack_public_path__ + "static/media/S3N13.2fa45861.svg";